exports.formatIban = (value) => {
    const uppercaseOnly = value.replace(/[^\dA-Z]/gi, '').toUpperCase();
    
    const formattedIban = uppercaseOnly.replace(/(.{4})/g, '$1 ').trim();
    return formattedIban;
};

exports.cleanIban = (value) => {
    const cleanedIban = value.replace(/\s/g, '');
    return cleanedIban;
}